module.exports = __webpack_public_path__ + "media/images/emblems/Siglistorf-blason-5d0542b7c792b86541c2b3617687d202.png";